import { v4 as uuid } from 'uuid';
import store from '@Store';
import { updateDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfAlertZeroResultsDialog } from '@Pages/Alerts/AlertsComponents/AlertZeroResultsDialog/AlertZeroResultsDialogConstants';
import UserDatabases from '@Services/UserDatabases';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import { MAP_CONTEXTS } from '@Pages/Hopinto/constants';
import Catalyst from '@Services/Catalyst';
import ResultsRunner from './ResultsRunner';

export function _runAlertSearch(request, callbacks) {
  const searchId = uuid();
  const requestId = uuid();
  const resultsRunner = new ResultsRunner({ searchId, requestId, ...request }, callbacks);

  return resultsRunner.run();
}

export function _showEmptyResultsDialog() {
  Catalyst.trackError({
    message: "Reaxys didn't find results for your query. Please consider reformulation and try again.",
    component: 'Alert',
  });
  store.dispatch(
    updateDialog({
      id: typeOfAlertZeroResultsDialog,
      dialogType: typeOfAlertZeroResultsDialog,
      movable: false,
      backdrop: true,
    })
  );
}

export const searchAlertResults = async ({ alert, context }) => {
  const queryFactItem = await MessageBroker.send(RequestUrls.hopintoUserAlert, { alert });

  const request = {
    queryFactItem,
    context: MAP_CONTEXTS[context] || context,
    databases: UserDatabases.getListWithIds(),
  };

  // eslint-disable-next-line no-return-await
  return await new Promise((resolve, reject) => {
    _runAlertSearch(request, {
      onSuccess: resolve,
      onEmptyResults: () => {
        _showEmptyResultsDialog();
        reject();
      },
    });
  });
};

export const searchAlertHitDetailsResults = async ({ alert, query, context }) => {
  const queryFactItem = await MessageBroker.send(RequestUrls.hopintoUserAlertHitDetails, { alert, context, query });

  const request = {
    queryFactItem,
    context: MAP_CONTEXTS[context] || context,
    databases: UserDatabases.getListWithIds(),
  };

  // eslint-disable-next-line no-return-await
  return await new Promise((resolve, reject) => {
    _runAlertSearch(request, {
      onSuccess: resolve,
      onEmptyResults: () => {
        _showEmptyResultsDialog();
        reject();
      },
    });
  });
};
